import { FormPropsInterface } from "./typings";

export function Form({loading, onSubmit, children}:FormPropsInterface) {
    return (
        <form className="form-horizontal" onSubmit={onSubmit} datatype="multipart/form-data">
            <fieldset disabled={loading}>
                {children}
            </fieldset>
        </form>
    );
}
